import type { RouteLocationNormalized } from "vue-router"

import { useUserStore } from "@/stores/user"
import checkPermissionConfig from "@/utils/checkPermissionConfig/index"

interface RouterProtectOptions {
    to: RouteLocationNormalized
    goBackPath?: { name: string }
    PERMISSIONS: string | string[]
    api: (id: unknown) => Promise<{ data: AssetResponse }>
    formatFunction?: (response: { data: AssetResponse }) => {
        data: AssetResponse
    }
}

interface AssetResponse {
    creator?: {
        department?: { uuid?: string }
        uuid?: string
        role?: { level?: number }
    }
    status?: string
    [key: string]: unknown
}

// 保護路由的實用函式，根據使用者權限進行判斷。
export default async function useRouterProtect({
    to,
    goBackPath = { name: "forbidden-index" },
    PERMISSIONS,
    api,
    formatFunction,
}: RouterProtectOptions): Promise<[true, { data: AssetResponse }] | [{ name: string }]> {
    try {
        const response = await api(to.params.id)
        const formatResponse = formatFunction ? formatFunction(response) : response
        const userStore = useUserStore()

        const hasPermissions = checkPermissionConfig(PERMISSIONS, userStore, {
            department: formatResponse.data.creator?.department?.uuid,
            status: formatResponse.data.status,
            creatorUuid: formatResponse.data.creator?.uuid,
            roleLevel: formatResponse.data.creator?.role?.level,
        })

        if (!hasPermissions) throw new Error("無權限訪問此頁面")
        return [true, response]
    } catch (error) {
        console.error(error)
        return [goBackPath]
    }
}
